// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-group-bordered{background:#f7f7f7;border-radius:3px;border:1px solid rgba(0,0,0,.38);position:relative}", ""]);
// Exports
module.exports = exports;
